import { createFileRoute } from '@tanstack/react-router';
import { BankDepositDetailPage } from '@/features/treasury/components/BankDepositDetailPage';

export const Route = createFileRoute('/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber')({
  component: BankDepositDetailPage,
});
